/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'remove': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4 7.2v1.6h8V7.2H4zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14.4A6.408 6.408 0 011.6 8c0-3.528 2.872-6.4 6.4-6.4 3.528 0 6.4 2.872 6.4 6.4 0 3.528-2.872 6.4-6.4 6.4z" _fill="#FF4242"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/remove.js